import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type Header } from '@tanstack/react-table';

import { Select } from '../../../../Select';
import { EFilterType } from '../../../types/table';

import styles from './SelectFilter.module.scss';

export interface ISelectFilterFilterProps {
    header: Header<any, unknown>;
    type: EFilterType;
    inline?: boolean;
}

export const SelectFilter: React.FC<ISelectFilterFilterProps> = ({ header: { column }, inline = false }) => {
    const { t } = useTranslation();
    const handleChange = (value: string) => {
        column.setFilterValue(value);
    };

    const selectOptions = useMemo(() => {
        const filtering = column.columnDef.meta?.filtering;
        if (filtering && filtering.type === EFilterType.equalsSelect && 'options' in filtering) {
            return filtering.options;
        }
        return [];
    }, [column.columnDef.meta?.filtering]);

    return (
        <Select
            className={inline ? styles.inlineSelect : undefined}
            size={inline ? 'small' : 'regular'}
            style={inline ? { minWidth: 0, width: '100%' } : { minWidth: 190 }}
            valueClassName={inline ? styles.inlineValue : undefined}
            placeholder={t('table.filtering.select')}
            value={(column.getFilterValue() as string) || ''}
            onValueChange={handleChange}
            options={selectOptions}
        />
    );
};
